import HeaderBar from "../../../components/header/headerBar";
import { SearchField } from "../../../components/textfield";
import { Table, TableColumn } from "../../../components/table";
import MainButton from "../../../components/button/mainButton";
import img from "../../../assets/images/Robert.png";
import { useHistory } from "react-router";
import "../../../assets/styles/admin/personnel.scss";
import EmptyModel from "../../../components/modal/emptyModal";
import { useState, useEffect } from "react";
import { Modal, Row, Col, Avatar, Image } from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import { getLocalUrl } from "../../../functions";
import { getFileHostUrl } from "../../../helpers/functions";

const Personnel = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [textModal, setTextModal] = useState("");
  const [countPage, setCountPage] = useState(1);
  const [page, setPage] = useState(1);
  const [datas, setDatas] = useState([]);
  const [picture, setPicture] = useState("");

  const option = [
    { value: "branch1", name: "All" },
    { value: "branch2", name: "All" },
    { value: "branch3", name: "All" },
    { value: "branch4", name: "All" },
  ];

  const columns = [
    {
      title: "",
    },
    {
      title: "EN",
      align: "center",
    },
    {
      title: "Name - Surname",
      align: "center",
    },
    {
      title: "Personnel Types",
      align: "center",
    },
    {
      title: "User Group type",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];

  const data = [
    {
      _id: 1,
      picture: "",
      en: "ENM58050001",
      name: "Leslie Alexander",
      user_command: "Marketing",
    },
    {
      _id: 2,
      picture: "",
      en: "ENB58050001",
      name: "Ronald Richards",
      user_command: "ผู้บริหาร",
    },
    {
      _id: 3,
      picture: "",
      en: "ENO58050001",
      name: "Jane Cooper",
      user_command: "Marketing",
    },
    {
      _id: 4,
      picture: img,
      en: "ENAM58050001",
      name: "Robert Fox",
      user_command: "Operation",
    },
    {
      _id: 5,
      picture: "",
      en: "ENA58050001",
      name: "Jane Cooper",
      user_command: "ผู้ดูแลระบบ",
    },
  ];

  function onClose() {
    setIsOpen(false);
  }
  const deleteData = (id: any) => {
    console.log("id", id);

    axios.delete(`/users/${id}`).then((res) => {
      console.log(res.data);
      setTimeout(() => getdata(), 200);
    });
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          {console.log("name", name)}
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${
            name?.firstNameEN + "-" + name?.lastNameEN
          } ออกหรือไม่ ?`}</div>
          <div>{`Are You Sure Delete ${
            name?.firstNameEN + "-" + name?.lastNameEN
          } from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
      width: "fit-content",
    });
  }
  const getdata = async () => {
    await axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      console.log("datax", res?.data);

      setDatas(res?.data?.data);
      setCountPage(res?.data?.pages);
      setPage(res?.data?.page);
    });
  };
  const getPictrue = (pic: any) => {
    console.log("pic", pic);

    const picture = getFileHostUrl(pic);
    // setPicture(picture);
    return picture;
  };
  const getApis = () => {
    getdata();
  };
  useEffect(() => {
    getApis();
  }, []);

  return (
    <div>
      <HeaderBar title="PERSONNEL LIST" />
      <div style={{ padding: "0px 40px" }}>
        {/* <EmptyModel show={isOpen} onClose={onClose}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              height: "300px",
              paddingTop: "20px",
            }}
          >
            <IconMdi path={mdiAlertCircleOutline} size="80" color="#E76464" />
            <div className="col-12" style={{ textAlign: "center" }}>
              ต้องการลบรายการ {textModal} ออกหรือไม่ ?
            </div>
            <div className="justify-center">
              <MainButton
                className="mg-10"
                width="100px"
                title="ยกเลิก"
                background="#E76464"
                onClick={onClose}
              />

              <MainButton className="mg-10" width="100px" title="ตกลง" />
            </div>
          </div>
        </EmptyModel> */}
        <SearchField
          placeholder="Search for personnel (Name, User Group)"
          color="#fff"
        />
        <div className="selectWapper">
          {/* <div className="sCoin">
            <div className="text-select-wapper ">
              <Select title="BRANCH :" option={option} />
            </div>
            <div className="text-select-wapper">
              <Select title="STATUS :" option={option} />
            </div>
          </div> */}
          <Row className="filter-search">
            {/* <Col span={10} className="container-filter-search">
              <span>BRACH :</span>
              <Select />
            </Col>
            <Col span={10} className="container-filter-search">
              <span>STATUS :</span>
              <Select />
            </Col> */}
          </Row>
          <div className="btnCoin">
            <MainButton
              title="CREATE PERSONNEL"
              onClick={() => history.push(`personnel/personnelcreateNew`)}
              // to={`personnel/personnelcreateNew`}
            >
              <Icon
                icon="akar-icons:plus"
                width="20"
                height="20"
                color="white"
              />
            </MainButton>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {datas.map((item: any, index) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="5%" align="center">
                  <Avatar src={getPictrue(item.photoURL)} />
                </TableColumn>
                <TableColumn width="1%">{item?.code}</TableColumn>
                <TableColumn width="25%" align="center">
                  {item?.firstNameEN} - {item?.lastNameEN}
                </TableColumn>
                <TableColumn width="10%" align="center">
                  {item?.personnelType?.name}
                </TableColumn>
                <TableColumn width="10%" align="center">
                  {item?.permission?.name}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() =>
                      history.push(`personnel/${item?._id}/personneldetailNew`)
                    }
                  >
                    {/* <IconMdi
                      path={mdiEyeOutline}
                      size="24"
                      color="#5BAEA9"
                    ></IconMdi> */}
                    <Icon
                      icon="clarity:eye-line"
                      width="20"
                      height="20"
                      color="#5BAEA9"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      showDeleteConfirm(item?._id, item);
                    }}
                  >
                    <Icon
                      icon="icomoon-free:bin"
                      width="20"
                      height="20"
                      color="#FF6760"
                    />
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default Personnel;
